const getModule = () => import('./analytics.module')

const lazyLoadModule = [
  '$q',
  '$ocLazyLoad',
  ($q, $ocLazyLoad) => {
    const deferred = $q.defer()
    getModule().then(({ analyticsModule }) => {
      $ocLazyLoad.load({
        name: analyticsModule.name
      })
      deferred.resolve(analyticsModule)
    })
    return deferred.promise
  }
]

const checkModuleEnabled = [
  '$q',
  '$state',
  '$rootScope',
  ($q, $state, $rootScope) => {
    const deferred = $q.defer()
    const promises = [$rootScope.getCompanyFeaturesAndAddons(), $rootScope.getUser()]

    $q.all(promises).then(([{ features }, user]) => {
      if ((features['ANALYTICS.ACCESS'] && $rootScope.isUserSysAdminAdmin(user)) || $rootScope.isUserSysAdmin(user)) {
        deferred.resolve()
      } else {
        deferred.reject()
      }
    })

    return deferred.promise
      .catch(() => {
        $state.go('home')
      })
  }
]

/* @ngInject */
function routes ($stateProvider, $urlRouterProvider) {
  $stateProvider
    .state('analytics', {
      url: '/analytics',
      abstract: true,
      views: {
        '': {
          templateUrl: '/analytics/analytics.html?$$REVISION$$'
        },
        'secondLevelMenu@analytics': {
          templateUrl: '/analytics/directives/analytics-sidebar-menu/analytics-sidebar-menu.html?$$REVISION$$',
          controller: 'AnalyticsSideBarMenuController'
        }
      },
      resolve: {
        lazyLoadModule,
        checkModuleEnabled
      }
    })
    .state('analytics.dashboard', {
      parent: 'analytics',
      url: '/:slug?periodStart&periodEnd&version&utm_source&utm_campaign',
      reloadOnSearch: false,
      views: {
        'dashboard@analytics': {
          templateUrl: '/analytics/pages/analytics-page/analytics-page.html?$$REVISION$$',
          controller: 'AnalyticsPageController'
        }
      },
      resolve: {
        lazyLoadModule,
        checkModuleEnabled
      },
      params: {
        periodStart: null,
        periodEnd: null,
        version: null,
        filterName: null,
        filterValue: null,
        utm_source: null,
        utm_campaign: null
      }
    })

  $urlRouterProvider.when('/analytics/', '/analytics')
}

export const analyticsRoutes = routes
